import { When } from 'react-if';
import { useTranslation } from 'next-i18next';
import { LoadingSpinner } from '../../../common/Loading';
import { useSubscriptionPaymentContext } from '../hooks';
export const PaymentLoading = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    isSubmitLoading
  } = useSubscriptionPaymentContext();
  return <When condition={isSubmitLoading} data-sentry-element="When" data-sentry-component="PaymentLoading" data-sentry-source-file="PaymentLoading.tsx">
      <LoadingSpinner text={t('subscription:paymentPayple.alertLoading.processing')} description={t('subscription:paymentPayple.alertLoading.description')} data-sentry-element="LoadingSpinner" data-sentry-source-file="PaymentLoading.tsx" />
    </When>;
};